import { COLORS } from '@/styles/color';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize } from '@/styles/typography/utils';
import { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react';
import styled from 'styled-components';

const TagButton = styled.button`
  ${customTextSize(12, 15)}
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  letter-spacing: 0.03em;
  text-transform: uppercase;
  text-align: center;
  appearance: none;
  background-color: ${COLORS.GRAY.HIGHLIGHT};
  color: #8b8b8b;
  padding: 7px;
  border-radius: 7px;
  text-transform: uppercase;

  transition: background-color 0.15s ease-in-out, color 0.15s ease-in-out;

  &:focus {
    outline-color: ${COLORS.BLACK};
  }

  &[data-active='true'] {
    background-color: ${COLORS.BLACK};
    color: ${COLORS.WHITE};
  }

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(15, 17)}
  }
`;

interface TagProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  text: string;
  active: boolean;
}

const Tag = forwardRef<HTMLButtonElement, TagProps>((props, ref) => {
  return (
    <TagButton data-active={props.active} {...props} ref={ref}>
      {props.text}
    </TagButton>
  );
});

Tag.displayName = 'Tag';

Tag.defaultProps = {
  active: false,
};

export default Tag;
